module.exports = __webpack_public_path__ + "static/media/KaTeX_Size1-Regular.f2e296ef.ttf";